import { getMe } from "@elation/api-client/src/stitch-web";

import {
  trackSessionInitFailure,
  trackUserLoggedIn,
} from "@src/shared/utils/observability/trackUserLoggedIn";

/**
 * Records the analytics for a completed email/password login. Called from
 * whichever step actually establishes the session — the sign-in call when 2FA is
 * off, or the second-factor verification when it is on.
 */
export async function trackEmailLoginSuccess(): Promise<void> {
  try {
    const { data: me } = await getMe();

    trackUserLoggedIn(me, "email");
  } catch (err) {
    console.error("Failed to record login analytics:", err);
    trackSessionInitFailure("email", err);
  }
}
